import {ReasonType} from '@web/core/constants'

export const familyPayFailureRejectValue = {
    title: '',
    code: ReasonType.INVALID_EXPECTED_REWARD_POINT_FETCH_BY_INVALID_FAMILY_PAY_INFO,
    detail: '',
    fallbackMessage: '패밀리결제 정보 조회로 인한 실패',
    status: 0,
    validationFailure: {
        fallbackMessage: '',
        message: '',
        reasonAttributes: {},
        reasonType: '',
    },
}

export const ReceivePointActionResultCode = {
    /** 성공 */
    SUCCESS: 'SUCCESS',
    /** 이미 적립된 거래 */
    ALREADY_RECEIVED: 'ALREADY_RECEIVED',
    /** 유효하지 않은 요청 (적립 거래 없음(적립기준일 없음) = 다른 계정으로 접근 등) */
    INVALID_REQUEST: 'INVALID_REQUEST',
    /** 포인트 받기 가능한 기간이 아님 */
    PERIOD_NOT_ACTIVE: 'PERIOD_NOT_ACTIVE',
    /** 그 외 실패 */
    FAILED: 'FAILED',
} as const

/** API Result Code ➡️ Action Result Code */
export const ReceivePointCodeMap: Record<string, Constant<typeof ReceivePointActionResultCode>> = {
    /** 성공 */
    '1000': ReceivePointActionResultCode.SUCCESS,
    /** 이미 적립된 거래 */
    '1001': ReceivePointActionResultCode.ALREADY_RECEIVED,
    /** 유효하지 않은 요청 (적립 거래 없음(적립기준일 없음) = 다른 계정으로 접근 등) */
    P002: ReceivePointActionResultCode.INVALID_REQUEST,
    /** 포인트 받기 가능한 기간이 아님 */
    '9999': ReceivePointActionResultCode.PERIOD_NOT_ACTIVE,
}
